<template>
  <el-dialog :visible.sync="show" width="100%" fullscreen :append-to-body="appendToBody" :before-close="closed">
    <div style="height: calc(100vh - 60px)">
        <h3 style="text-align:center;margin-bottom:20px">{{title}}</h3>
      <iframe :id="iviewId" class="iframe"  v-if="iframeUrl"  :src="iframeUrl"></iframe>
    </div>
  </el-dialog>
</template>

<script>
  import {delBpmId} from "@/api/bpmnApi/bpmn"
export default {
  name: "IframeView",
  components: {},
  props: {
    "append-to-body": {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      iframeUrl: "",
        iviewId: '',
        taskInstId: "",
      hideType: 0,
      title:""
    };
  },
  computed: {},
  created() {},
  mounted() {
      window.addEventListener("message", this.listerIframeOff);
  },
  destroyed() {
      window.removeEventListener("message", this.listerIframeOff);
  },
  methods: {
    showView(url, taskInstId,title) {
        if (!url) {
        return;
      }
      this.title = title
      this.iframeUrl = url;
      this.iviewId = 'iframeId' + taskInstId ;
      this.taskInstId = taskInstId;
      this.hideType = 0;
      this.show = true;
    },
    listerIframeOff(e) {
        if (e.data.code == "aws-hide") {
        this.hideType = e.data.hideType;
        window.sessionStorage.setItem("processInstId", "");
        this.$nextTick(() => {
            this.iframeUrl = ""
            this.$emit('sub-true')
            this.show = false;
        });
      }
    },
    closed() {
        let iframe = document.getElementById(this.iviewId)
        iframe.contentWindow.postMessage({
            code: 'web',
            taskInstId: this.taskInstId
        }, '*')
        if(window.sessionStorage.getItem("processInstId")){
            this.$confirm( "确认是否退出并保存该条申请?", "提示", {
                confirmButtonText: '保存',
                cancelButtonText: '不保存',
                type: 'warning'
            }).then(() => {
                iframe.contentWindow.postMessage({
                    code: 'doSaveData',
                    taskInstId: this.taskInstId
                }, '*')
                this.show = false
                window.sessionStorage.setItem("processInstId", '');
                setTimeout(() =>{
                    this.iframeUrl = "";
                }, 1000)
                switch (this.hideType) {
                    case 1:
                        this.$emit("fetch-list");
                        break;
                    case 2:
                        this.$emit("init-page");
                        break;
                    case 3:
                        window.location.reload();
                        break;
                    default:
                        this.$emit("fetch-list");
                        break;
                }
            }).catch(() => {
                let params = {
                    instId: window.sessionStorage.getItem("processInstId") || ''
                }
                delBpmId(params).then((res) =>{
                    if(res.data.code == '0'){
                        this.$message.success("删除流程成功" );
                        window.sessionStorage.setItem("processInstId", '');
                        this.iframeUrl = "";
                        switch (this.hideType) {
                            case 1:
                                this.$emit("fetch-list");
                                break;
                            case 2:
                                this.$emit("init-page");
                                break;
                            case 3:
                                window.location.reload();
                                break;
                            default:
                                this.$emit("fetch-list");
                                break;
                        }
                        this.show = false
                    }else {
                        this.$message.warning(res.data.msg||"删除流程失败，请重新操作!" );
                    }
                })
            });
        }else {
            this.show = false;
            switch (this.hideType) {
                case 1:
                    this.$emit("fetch-list");
                    break;
                case 2:
                    this.$emit("init-page");
                    break;
                case 3:
                    window.location.reload();
                    break;
                default:
                    this.$emit("fetch-list");
                    break;
            }
        }
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
